import { Component, OnInit } from "@angular/core";
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { GlobalSettings } from "../../../../../model/settings.model";
import { ProcessService } from "src/app/service/process.service";
import { NotifierService } from "angular-notifier";
import swal from "sweetalert2";
import "hammerjs";
import {
  NgxGalleryOptions,
  NgxGalleryImage,
  NgxGalleryAnimation
} from "@kolkov/ngx-gallery";
import { ComponentBase } from "src/app/main/dynamic/component-base";
import { DndDropEvent, DropEffect } from "ngx-drag-drop";
import { AuthenticationService } from "src/app/service/auth.service";
import { environment } from "src/environments/environment";
import { UserModel } from "src/app/model/user.model";
import { AttributeModel } from "src/app/main/dynamic/model/attribute.model";
import { OptionModel } from "src/app/main/dynamic/model/option.model";

@Component({
  selector: "app-upload",
  templateUrl: "./upload.component.html",
  styleUrls: ["./upload.component.scss"]
})
export class UploadComponent extends ComponentBase implements OnInit {
  /*Dragdrop Star*/
  draggableListLeft = [
    {
      content: "Left",
      effectAllowed: "move",
      disable: false,
      handle: false
    },
    {
      content: "Lefter",
      effectAllowed: "move",
      disable: false,
      handle: false
    },
    {
      content: "Leftest",
      effectAllowed: "copyMove",
      disable: false,
      handle: false
    },
    {
      content: "Lefty",
      effectAllowed: "move",
      disable: false,
      handle: true
    }
  ];

  draggableListRight = [
    {
      content: "I was originally right",
      effectAllowed: "move",
      disable: false,
      handle: false
    }
  ];

  layout: any;
  horizontalLayoutActive: boolean = false;
  private currentDraggableEvent: DragEvent;
  private currentDragEffectMsg: string;
  private readonly verticalLayout = {
    container: "row",
    list: "column",
    dndHorizontal: false
  };
  private readonly horizontalLayout = {
    container: "row",
    list: "row",
    dndHorizontal: true
  };
  /*Dragdrop end*/

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  StartAttribute: AttributeModel;
  imagePath: any;
  attributeModel: AttributeModel;
  files: AttributeModel;
  service: string;
  pathFile: string = this.settings.processosUrl;
  load: boolean = true;
  galleryKey: string;
  itemGallery: any;
  //dropzone
  public type: string = "component";
  private saveDebounceHandle: any;
  private authUser: UserModel
  private static readonly OWN_MSG = "[bf]";
  private static readonly MIME_BY_EXT: { [ext: string]: string } = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    heic: "image/heic",
    heif: "image/heif",
    webp: "image/webp",
    gif: "image/gif",
    bmp: "image/bmp",
    tif: "image/tiff",
    tiff: "image/tiff",
    svg: "image/svg+xml",
    pdf: "application/pdf",
    txt: "text/plain"
  };
  public readonly isIOS: boolean =
    /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase()) ||
    (window.navigator.platform === "MacIntel" &&
      (window.navigator as any).maxTouchPoints > 1);
  iosThumbFailed: { [key: string]: boolean } = {};
  public config: DropzoneConfigInterface = {
    uploadMultiple: false,
    autoReset: 1,
    clickable: true,
    maxFilesize: 10,
    maxFiles: 10,
    headers: {
      Authorization: `Bearer ${this.authService.getToken()}`
    },
    previewTemplate:
      '<div class="dz-preview dz-file-preview drop-test"><div class="dz-image"><img data-dz-thumbnail /></div><div class="dz-details"><div class="dz-size"><span data-dz-size></span></div><div class="dz-filename"><span data-dz-name></span></div></div><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div><div class="dz-error-message"><span data-dz-errormessage></span></div></div>',
    url: `${this.settings.processosUrl}/process/Files/${sessionStorage.getItem("processId")}`,
    paramName: "file"
  };

  constructor(
    private settings: GlobalSettings,
    private processService: ProcessService,
    private notifier: NotifierService,
    private authService: AuthenticationService
  ) {
    super();
    this.setHorizontalLayout(this.horizontalLayoutActive);
  }

  get acceptedFiles(): string {
    if(!this.attribute) {
      return null;
    }

    const acceptedFilesOpt = this.attribute.options.find(
      opt => opt.key.toLowerCase() == "acceptedFiles".toLowerCase()
    ); 
    if (acceptedFilesOpt) {
      return acceptedFilesOpt.value;
    }
    return null;
  }

  get acceptedFilesForDropzone(): string {
    const raw = this.acceptedFiles;
    if (!raw) {
      return null;
    }

    const entries = raw
      .split(",")
      .map(entry => entry.trim())
      .filter(entry => entry.length > 0);
    const result: string[] = [];
    const seen: { [value: string]: boolean } = {};
    const mimeToExts: { [mime: string]: string[] } = {};

    Object.keys(UploadComponent.MIME_BY_EXT).forEach(ext => {
      const mime = UploadComponent.MIME_BY_EXT[ext];
      if (!mimeToExts[mime]) {
        mimeToExts[mime] = [];
      }
      mimeToExts[mime].push("." + ext);
    });

    const add = (value: string) => {
      if (!value || seen[value]) {
        return;
      }
      seen[value] = true;
      result.push(value);
    };

    entries.forEach(entry => {
      add(entry);

      if (entry.charAt(0) === ".") {
        const mime = UploadComponent.MIME_BY_EXT[entry.substring(1).toLowerCase()];
        if (mime) {
          add(mime);
          (mimeToExts[mime] || []).forEach(alias => add(alias));
        }
      } else if (entry.indexOf("/") !== -1 && entry.indexOf("/*") === -1) {
        (mimeToExts[entry.toLowerCase()] || []).forEach(alias => add(alias));
      }
    });

    return result.join(",");
  }

  get defaultMessage(): string {
    let message = `<i></i> Clique para escolher ou arraste os arquivos aqui! <small>Max. de ${this.maxFiles} arquivo(s) e 10mb de tamanho.</small>`;

    if (this.acceptedFiles) {
      message += `Somente arquivos dos tipos ${this.acceptedFiles} serão aceitos.`;
    }

    return message
  }

  get hasNonImages(): boolean {
    return this.attribute.attributes
      .some(attr => this.isNotImage(attr))
  }

  get hasImages(): boolean {
    let hasSomeImg = this.attribute.attributes
      .some(attr => !this.isNotImage(attr));
    return hasSomeImg;
  }

  get maxFiles(): number {
    const maxFilesOpt = this.attribute.options.find(
      opt => opt.key.toLowerCase() == "maximumfiles"
    ); 
    if (maxFilesOpt) {
      return +maxFilesOpt.value;  
    }
    return 10;
  }

  get uploadDisabled(): boolean {
    return this.disabled || this.attribute.attributes.length >= this.maxFiles;
  }

  get uploadErrorText(): string {
    const errorText = this.getError();

    const minFilesOpt = this.attribute.options.find(
      opt => opt.key.toLowerCase() == "minimumfiles"
    );

    if (minFilesOpt) {
      if (this.attribute.attributes.length < +minFilesOpt.value) {
        return errorText;
      }
    } else if (errorText && this.attribute.attributes.length == 0) {
      return errorText;
    }

    return "";
  }

  ngOnInit() {
    this.loadGalleryComponent();
    this.authUser = this.authService.getUser() ;
    this.config.maxFiles = this.maxFiles;
    this.config.acceptedFiles = this.acceptedFilesForDropzone;
    if (this.isIOS) {
      this.enableIosFileSnapshot();
    }
  }

  private enableIosFileSnapshot(): void {
    const own = UploadComponent.OWN_MSG;
    const limitMsg = `${own}Máximo de ${this.maxFiles} arquivo(s) por envio.`;

    this.config.createImageThumbnails = false;

    this.config.accept = function (this: any, file: any, done: Function) {
      if (this.options.maxFiles != null && this.files.length > this.options.maxFiles) {
        return done(limitMsg);
      }

      const reader = new FileReader();
      reader.onload = () => {
        const buffer = reader.result as ArrayBuffer;
        if (!buffer || buffer.byteLength === 0) {
          return done(
            `${own}Esta imagem chegou vazia. Se ela estiver no iCloud, abra o app Fotos, espere baixar por completo e tente de novo.`
          );
        }
        file._iosCopy = new Blob([buffer], {
          type: file.type || "application/octet-stream"
        });
        done();
      };
      reader.onerror = () =>
        done(
          `${own}Não foi possível ler esta imagem no iPhone. Tire uma foto nova pela câmera ou escolha o arquivo pelo app Arquivos.`
        );
      reader.readAsArrayBuffer(file);
    };

    this.config.transformFile = (file: any, done: Function) =>
      done(file._iosCopy || file);
  }

  private loadGalleryComponent() {
    this.galleryOptions = [
      {
        width: "100%",
        height: "150px",
        image: false,
        imageSwipe: true,
        thumbnailsSwipe: true,
        previewSwipe: true,
        imageDescription: true,
        thumbnailsColumns: 5,
        thumbnailsRows: 1,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
        previewForceFullscreen: false,
        startIndex: 1,
        imageInfinityMove: true,

      },
      {
        breakpoint: 1300,
        width: "100%",
        height: "150px",
        image: false,
        thumbnailsColumns: 4,
      },
      {
        breakpoint: 800,
        height: "100px",
      },
      {
        breakpoint: 500,
        thumbnailsColumns: 2,
      },
    ];
    this.galleryImages = [];
    setTimeout(() => {
      this.galleryImages = [];
      this.loadGallery();
    }, 1000);
  }

  /*Begin Drag*/
  setHorizontalLayout(horizontalLayoutActive: boolean) {
    this.layout = horizontalLayoutActive
      ? this.horizontalLayout
      : this.verticalLayout;
  }

  onDragStart(event: DragEvent) {
    this.currentDragEffectMsg = "";
    this.currentDraggableEvent = event;
  }

  onDragged(item: any, list: any[], effect: DropEffect) {
    this.currentDragEffectMsg = `Drag ended with effect "${effect}"!`;

    if (effect === "move") {
      const index = list.indexOf(item);
      list.splice(index, 1);
    }

    this.save();
  }

  onDragEnd(event: DragEvent) {
    this.currentDraggableEvent = event;
  }

  onDrop(event: DndDropEvent, list?: any[]) {
    if (list && (event.dropEffect === "copy" || event.dropEffect === "move")) {
      let index = event.index;

      if (typeof index === "undefined") {
        index = list.length;
      }

      list.splice(index, 0, event.data);
    }
  }

  /*End Drag*/

  canView(): boolean {
    let viewOpt = this.attribute.options.find(
      opt => opt.key.toLowerCase() == "view"
    );

    if (viewOpt) {
      return viewOpt.value.toLowerCase() == "show";
    }

    return true;
  }

  getPath(key: string) {
    return `${this.pathFile}/process/Files/${key}?tenant-id=${this.authUser.tenantId}&env=${environment.name}`;
  }

  onIosThumbError(key: string): void {
    if (!this.isIOS || !key) {
      return;
    }
    this.iosThumbFailed[key] = true;
  }

  returnUpload: {
    id: string;
    processId: string;
    name: string;
  };

  delete(item: AttributeModel) {
    this.processService.deleteFile(item.key).subscribe(() => {
      let atributo: any = this.attribute.attributes.filter(
        element => element !== item
      );
      this.attribute.attributes = atributo;
      this.save();
    });
  }

  onDelete(item: AttributeModel) {
    swal.fire({
      title: "Atenção",
      text: "Deseja realmente excluir?",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Não",
      confirmButtonText: "Sim"
    }).then(result => {
      console.log(result);
      if (result.value) {
        this.delete(item);
      }
    });
  }

  loadGallery() {
    if (this.load) {
      let images = this.attribute.attributes.filter(
        image =>
          image.type.toLocaleLowerCase() == "png" ||
          image.type.toLocaleLowerCase() == "jpg" ||
          image.type.toLocaleLowerCase() == "jpeg" ||
          image.type.toLocaleLowerCase() == "pjpeg" ||
          image.type.toLocaleLowerCase() == "bmp" ||
          image.type.toLocaleLowerCase() == "tiff" ||
          image.type.toLocaleLowerCase() == "gif" ||
          image.type.toLocaleLowerCase() == "webp" ||
          image.type.toLocaleLowerCase() == "svg"
      );
      
      if (images != undefined) {
        images.forEach(element => {
          let description = element.attributes.find(
            text => text.key == "description"
          );
          let img = {
            small: this.getPath(element.key),
            medium: this.getPath(element.key),
            big: this.getPath(element.key),
            description: description != undefined ? description.value : ""
          };
          this.galleryImages.push(new NgxGalleryImage(img));
        });
      }
    }
  }

  firstFunction() {
    //this.attribute.attributes.length
    // console.log('event' + key);
  }

  ngGetSequence(attributeModel: AttributeModel): string {
    return attributeModel.attributes[0].value;
  }

  public onUploadError(args: any): void {
    if (args && args.length > 1 && args[1]) {
      let errorMessage = "Houve um erro inesperado.";
      const message = args[1];
      const xhr = args[2];

      if (typeof message === "string") {
        if (message.indexOf(UploadComponent.OWN_MSG) === 0) {
          errorMessage = message.substring(UploadComponent.OWN_MSG.length);
        } else if (message.includes("File is too big")) {
          errorMessage = "Arquivo maior que o esperado. Tamanho máximo de 10MB";
        } else if (message.includes("files of this type")) {
          errorMessage = `Somente arquivos dos tipos ${this.acceptedFiles} serão aceitos.`;
        }
      }

      if (
        errorMessage === "Houve um erro inesperado." &&
        xhr &&
        xhr.status === 400
      ) {
        errorMessage =
          "Não foi possível enviar a foto neste iPhone. Tente de novo ou escolha a imagem em Arquivos.";
      }

      if (args[0]) {
        args[0]._iosCopy = null;
        setTimeout(() => {
          args[0].previewElement?.remove();
          args[0].previewElement = null;
        }, 10);
      }

      swal.fire("Atenção", errorMessage, "error");
    }
  }

  public onUploadComplete(args: any): void {
    if (args && args[0]) {
      args[0]._iosCopy = null;
    }
  }

  public onUploadSuccess(args: any): void {
    this.returnUpload = JSON.parse(args[0].xhr.response);
    let file: AttributeModel = new AttributeModel();
    let fileDetail: AttributeModel = new AttributeModel();
    let fileOption: OptionModel = new OptionModel();
    let optionDetail: OptionModel[] = [];
    var ext = this.returnUpload[0].name.substr(
      this.returnUpload[0].name.lastIndexOf(".") + 1
    );
    file.key = this.returnUpload[0].id;
    file.value = "";

    fileDetail.key = "sequence";
    fileDetail.value = "1";
    fileDetail.type = "number";
    /*Options*/
    fileOption.key = "view";
    fileOption.value = "hide";
    fileOption.type = "text";
    optionDetail.push(fileOption);
    fileOption = new OptionModel();
    fileDetail.options = optionDetail;
    file.attributes.push(fileDetail);
    optionDetail = [];

    fileDetail = new AttributeModel();
    fileDetail.key = "fileName";
    fileDetail.value = this.returnUpload[0].name;
    fileDetail.type = "text";
    /*Options*/
    fileOption.key = "view";
    fileOption.value = "both";
    fileOption.type = "text";
    optionDetail.push(fileOption);
    fileOption = new OptionModel();

    fileDetail.options = optionDetail;
    file.attributes.push(fileDetail);
    optionDetail = [];

    fileDetail = new AttributeModel();
    fileDetail.key = "description";
    fileDetail.value = "";
    fileDetail.type = "textarea";
    /*Options*/
    fileOption.key = "view";
    fileOption.value = "both";
    fileOption.type = "text";
    optionDetail.push(fileOption);
    fileOption = new OptionModel();

    fileOption.key = "placeholder";
    fileOption.value = "Descrição";
    fileOption.type = "text";
    optionDetail.push(fileOption);
    fileOption = new OptionModel();

    fileOption.key = "maxlength";
    fileOption.value = "1000";
    fileOption.type = "text";
    optionDetail.push(fileOption);
    fileOption = new OptionModel();

    fileDetail.options = optionDetail;
    file.attributes.push(fileDetail);
    optionDetail = [];
    file.type = ext;

    this.attribute.attributes.push(file);
    this.save();
  }

  save() {
    this.scheduleSave();
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  onblur() {
    this.save();
  }

  imagesLoaded(event: any) {
    console.log(event);
  }

  private scheduleSave(): void {
    if (this.saveDebounceHandle) {
      clearTimeout(this.saveDebounceHandle);
    }
    this.saveDebounceHandle = setTimeout(() => {
      this.performSave();
      this.saveDebounceHandle = null;
    }, 150);
  }

  private performSave(): void {
    // Não salvar diretamente aqui para evitar duplicidade.
    // O salvamento será tratado pelo SectionComponent ao receber o evento 'autosave'.
    this.emitEvents([
      { name: "autosave" }
    ])
  }

  getName(name: string): string {
    let value: string;
    value = name
      .trim()
      .split(" ")
      .join("")
      .replace("/", "");
    return value;
  }

  getFilename(attribute:AttributeModel[]):string{
    let name = '';
    attribute.forEach(element => {
      if (element.key == 'fileName')
        name = element.value;
    });

    return name;;
  }

  isEmpty(): boolean{
    return this.attribute.attributes.length == 0;
  }

  isNotImage(file: AttributeModel): boolean {
    return file.type.toLowerCase()!='png' && 
      file.type.toLowerCase()!='jpg' && 
      file.type.toLowerCase()!='jpeg' && 
      file.type.toLowerCase()!='pjpeg' && 
      file.type.toLowerCase()!='bmp' && 
      file.type.toLowerCase()!='tiff' && 
      file.type.toLowerCase()!='gif' && 
      file.type.toLowerCase()!='webp' && 
      file.type.toLowerCase()!='svg'
  }

  getNonImageFiles(): AttributeModel[] {
    return this.attribute.attributes
      .filter(attr => this.isNotImage(attr))
  }
}